
import { HeroSection } from './components/HeroSection';
import { CoreValuesSection } from './components/CoreValuesSection';
import { SolutionsPreviewSection } from './components/SolutionsPreviewSection';
import { GlobalPresenceSection } from './components/GlobalPresenceSection';
import { AboutSection } from './components/AboutSection';
import { AdvantagesSection } from './components/AdvantagesSection';
import { ContactSection } from './components/ContactSection';
import { FooterSection } from './components/FooterSection';
import { CursorGlow } from './components/CursorGlow';
import Aurora from './components/Aurora';

export default function HomePage() {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Global Aurora Background */}
      <div className="fixed inset-0 z-0">
        <Aurora 
          colorStops={['#1e40af', '#3b82f6', '#0ea5e9']}
          amplitude={1.2}
          blend={0.4}
          speed={0.6}
        />
      </div>
      
      {/* Global Effects */}
      <CursorGlow />
      
      {/* Content with relative positioning */}
      <div className="relative z-10">
        <HeroSection />
        
        {/* Sections with subtle overlay */}
        <div className="relative">
          <div className="absolute inset-0 bg-black/20 z-0"></div>
          <div className="relative z-10">
            <CoreValuesSection />
            <SolutionsPreviewSection />
            <GlobalPresenceSection />
            <AboutSection />
            <AdvantagesSection />
            <ContactSection />
            <FooterSection />
          </div>
        </div>
      </div>
    </div>
  );
}
